// extracted by mini-css-extract-plugin
export default {"concentrationIcon":"styles_concentrationIcon__BsaNr","svg":"styles_svg__Jr+M-"};